import { useEffect, useState } from 'react';

interface EnrollData {
  secret: string;
  qr_data_url: string;
}

export default function MfaEnroll({
  pendingToken,
  onDone,
}: {
  pendingToken: string;
  onDone: () => void;
}) {
  const [data, setData] = useState<EnrollData | null>(null);
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    fetch(`/api/auth/mfa/enroll?pending_token=${encodeURIComponent(pendingToken)}`)
      .then(async (res) => {
        const body = await res.json();
        if (!res.ok) throw new Error(body?.error ?? `request failed: ${res.status}`);
        setData(body);
      })
      .catch((e) => setError((e as Error).message));
  }, [pendingToken]);

  async function confirm() {
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      const res = await fetch('/api/auth/mfa/enroll/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pending_token: pendingToken, code }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body?.error ?? `request failed: ${res.status}`);
      onDone();
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <p className="card-sub" style={{ marginBottom: 12 }}>
        Scan this QR code with an authenticator app (Google Authenticator, 1Password, Authy), then enter the
        6-digit code it shows.
      </p>
      {error && <div className="errors">{error}</div>}
      {!data ? (
        <div className="empty">Loading…</div>
      ) : (
        <>
          <img src={data.qr_data_url} alt="TOTP QR code" style={{ width: 200, height: 200, marginBottom: 8 }} />
          <div className="card-sub code" style={{ marginBottom: 16, wordBreak: 'break-all' }}>
            Can&apos;t scan? Enter manually: {data.secret}
          </div>
          <input
            type="text"
            inputMode="numeric"
            placeholder="123456"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            style={{ fontSize: 18, letterSpacing: 4, textAlign: 'center', width: '100%', maxWidth: 200, marginBottom: 12 }}
          />
          <div>
            <button className="btn btn-primary" type="button" disabled={busy || code.length !== 6} onClick={confirm}>
              Verify &amp; finish
            </button>
          </div>
        </>
      )}
    </div>
  );
}
